module.exports = __webpack_public_path__ + "static/media/clipboard.d5681166.svg";